module.exports = __webpack_public_path__ + "img/cs_cart.1359e005.png";